export default __webpack_public_path__ + "static/media/REL-EXT-30A.d4201e1d.png";